import React from "react";
import { Button } from "antd";
import { useDispatch } from "react-redux";
import { MESSAGES_INFO } from "../../redux/actions/messagesActions";
import { ReactComponent as ArrowIcon } from "../../assets/svg/icons/chevron-right.svg";
var ScrollDownButton = function (_a) {
    var dialogId = _a.dialogId, chatType = _a.chatType;
    var dispatch = useDispatch();
    var handleScrollDown = function () {
        dispatch({
            type: MESSAGES_INFO,
            payload: {
                dialog_id: dialogId,
                blockReloadChat: true,
                loaderDisabled: true,
                type_chat: chatType,
                noResetForNewMessages: true,
            },
        });
    };
    return (React.createElement(Button, { onClick: handleScrollDown, "aria-label": "Scroll down", shape: "circle", icon: React.createElement(ArrowIcon, { style: { width: "0.7rem" } }), "data-automation-id": "scroll-down-button", className: "scroll-down-button" }));
};
export default React.memo(ScrollDownButton);
